import { render, staticRenderFns } from "./PanelCompetitionResultsLiveAll.vue?vue&type=template&id=a3b7cc18&scoped=true&"
import script from "./PanelCompetitionResultsLiveAll.vue?vue&type=script&lang=js&"
export * from "./PanelCompetitionResultsLiveAll.vue?vue&type=script&lang=js&"
import style0 from "./PanelCompetitionResultsLiveAll.vue?vue&type=style&index=0&id=a3b7cc18&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3b7cc18",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/vhosts/dostartu.pl/app.startzone.online/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a3b7cc18')) {
      api.createRecord('a3b7cc18', component.options)
    } else {
      api.reload('a3b7cc18', component.options)
    }
    module.hot.accept("./PanelCompetitionResultsLiveAll.vue?vue&type=template&id=a3b7cc18&scoped=true&", function () {
      api.rerender('a3b7cc18', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/PanelCompetitionResultsLiveAll.vue"
export default component.exports